module.exports = __webpack_public_path__ + "img/footer_back.f0889473.png";